import { render, staticRenderFns } from "./RecoverPasswordCode.vue?vue&type=template&id=4e13fcfb&scoped=true&"
import script from "./RecoverPasswordCode.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordCode.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordCode.vue?vue&type=style&index=0&id=4e13fcfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13fcfb",
  null
  
)

export default component.exports